module.exports = __webpack_public_path__ + "img/logo.24be3200.jpeg";